import {keyBy} from 'lodash';

import {createResourcesUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {CalendarVersionModel} from '../../../models/api/calendarVersionModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {CalendarVersionsActionsEnum} from './calendarVersionsActions';

/*
 * Reducer.
 */

export const calendarsVersionsUpdatedReducer = createResourcesUpdatedReducer(
  'calendarVersions',
  (calendarVersion) => calendarVersion.id,
);

export function calendarVersionsReducer(
  state: ResourceMap<CalendarVersionModel>,
  action: AppAction,
): ResourceMap<CalendarVersionModel> {
  switch (action.type) {
    case DataGroupsActionsEnum.DATA_UPDATED:
      return calendarsVersionsUpdatedReducer(state, action);

    case CalendarVersionsActionsEnum.ALL_CALENDAR_VERSIONS_UPDATED:
      return keyBy(action.payload.calendarVersions, (c) => c.id);

    default:
      return state;
  }
}
